import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8de65ccc9e69352/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/InternalLinksSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/KioskCaseStudy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/KioskLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskShowcase"] */ "/tmp/8de65ccc9e69352/components/sections/KioskShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8de65ccc9e69352/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8de65ccc9e69352/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
